export default function React_Textarea() {
  return (
    <div>
      <h1>React_Textarea Component</h1>
      <p>This is the React_Textarea tutorial page.</p>
    </div>
  );
}
